import React from "react";
import { CloseIcon } from "../../../assets/icons";
import BannerIcon from "../../../assets/icons/bannerIcon";
import HourGlassIcon from "../../../assets/icons/HourglassIcon";
import AlertIcon from "../../../assets/icons/AlertIcon";

interface BankToast {
  color: string;
  type: string;
  message: string;
}

const BankToast: React.FC<BankToast> = (props) => {
  let bg =
    props.message === "Verifying Bank Details..."
      ? "#F1F8F5"
      : props.message.includes("Invalid") ||
          props.message.includes("Invalid registration code")
        ? "#FFE2E2"
        : "#F1F8F5";

  let border =
    props.message === "Verifying Bank Details..."
      ? "#20A852"
      : props.message.includes("Invalid") ||
          props.message.includes("Invalid registration code")
        ? "#D82020"
        : "#20A852";
  return (
    <div
      className={`flex items-center justify-center space-x-3 bg-[${bg}] px-12 py-2 rounded-lg border border-[${border}] mt-4
        `}
    >
      {props.message === "Verifying Bank Details..." ? (
        <HourGlassIcon color="#20A852" />
      ) : props.message.includes("verified") ? (
        <BannerIcon />
      ) : (
        <AlertIcon />
      )}
      <span className={`text-[15px] font-medium leading-7 text-[${border}]`}>
        {props.message}
      </span>
    </div>
  );
};

export default BankToast;
